import Vue from 'vue'

export default {
  getOrganizerProfile () {
    return Vue.prototype.$http.get('/organizer_profiles')
  },

  updateOrganizerProfile (organizerProfile) {
    return Vue.prototype.$http.put(`/organizer_profiles`, { organizer_profile: organizerProfile })
  }
}
